import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
const ProductionRoute = ({ children }) => <ProtectedRoute module="production">{children}</ProtectedRoute>;
const CrmRoute = ({ children }) => <ProtectedRoute module="crm">{children}</ProtectedRoute>;
const CustomersRoute = ({ children }) => <ProtectedRoute module="customers">{children}</ProtectedRoute>;
const ArtworkRoute = ({ children }) => <ProtectedRoute module="artwork">{children}</ProtectedRoute>;
const QuotationsRoute = ({ children }) => <ProtectedRoute module="quotations">{children}</ProtectedRoute>;
const SalesOrdersRoute = ({ children }) => <ProtectedRoute module="sales_orders">{children}</ProtectedRoute>;
const PlanningRoute = ({ children }) => <ProtectedRoute module="production_planning">{children}</ProtectedRoute>;
const QCRoute = ({ children }) => <ProtectedRoute module="quality_control">{children}</ProtectedRoute>;
const InventoryRoute = ({ children }) => <ProtectedRoute module="inventory">{children}</ProtectedRoute>;
const DispatchRoute = ({ children }) => <ProtectedRoute module="dispatch">{children}</ProtectedRoute>;
const FinanceRoute = ({ children }) => <ProtectedRoute module="finance">{children}</ProtectedRoute>;
const RawMaterialsRoute = ({ children }) => <ProtectedRoute module="raw_materials">{children}</ProtectedRoute>;
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import UserManagement from "@/pages/users/UserManagement";
import RolesPermissions from "@/pages/users/RolesPermissions";
import AuditLog from "@/pages/users/AuditLog";
import LoginHistory from "@/pages/users/LoginHistory";
import Reports from "@/pages/reports/Reports";
import Settings from "@/pages/settings/Settings";
import Placeholder from "@/pages/Placeholder";
import ProductionHub from "@/pages/production/ProductionHub";
import OperatorWorkspace from "@/pages/production/OperatorWorkspace";
import SupervisorDashboard from "@/pages/production/SupervisorDashboard";
import Enquiries from "@/pages/crm/Enquiries";
import EnquiryDetail from "@/pages/crm/EnquiryDetail";
import Customers from "@/pages/customers/Customers";
import CustomerForm from "@/pages/customers/CustomerForm";
import CustomerDetail from "@/pages/customers/CustomerDetail";
import ArtworkList from "@/pages/artwork/ArtworkList";
import ArtworkDetail from "@/pages/artwork/ArtworkDetail";
import Quotations from "@/pages/quotations/Quotations";
import QuotationForm from "@/pages/quotations/QuotationForm";
import QuotationDetail from "@/pages/quotations/QuotationDetail";
import SalesOrders from "@/pages/sales_orders/SalesOrders";
import SalesOrderForm from "@/pages/sales_orders/SalesOrderForm";
import SalesOrderDetail from "@/pages/sales_orders/SalesOrderDetail";
import Planning from "@/pages/planning/Planning";
import JobForm from "@/pages/planning/JobForm";
import JobDetail from "@/pages/planning/JobDetail";
import QualityControl from "@/pages/qc/QualityControl";
import InspectionDetail from "@/pages/qc/InspectionDetail";
import Inventory from "@/pages/inventory/Inventory";
import InventoryItemDetail from "@/pages/inventory/InventoryItemDetail";
import Dispatch from "@/pages/dispatch/Dispatch";
import DispatchDetail from "@/pages/dispatch/DispatchDetail";
import Finance from "@/pages/finance/Finance";
import InvoiceDetail from "@/pages/finance/InvoiceDetail";
import InvoicePrint from "@/pages/finance/InvoicePrint";
import RawMaterials from "@/pages/raw_materials/RawMaterials";
import MaterialDetail from "@/pages/raw_materials/MaterialDetail";
import Suppliers from "@/pages/suppliers/Suppliers";
import Purchase from "@/pages/purchase/Purchase";
import Machines from "@/pages/machines/Machines";
import Products from "@/pages/products/Products";
import HR from "@/pages/hr/HR";
import SiteLayout from "@/site/SiteLayout";
import Home from "@/site/Home";
import Collections from "@/site/Collections";
import ProductDetail from "@/site/ProductDetail";
import About from "@/site/About";
import Manufacturing from "@/site/Manufacturing";
import Gallery from "@/site/Gallery";
import Contact from "@/site/Contact";
import TryStudio from "./site/TryStudio";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/users" element={<ProtectedRoute module="user_management"><UserManagement /></ProtectedRoute>} />
              <Route path="/roles" element={<ProtectedRoute module="user_management"><RolesPermissions /></ProtectedRoute>} />
              <Route path="/audit-logs" element={<ProtectedRoute module="user_management"><AuditLog /></ProtectedRoute>} />
              <Route path="/login-history" element={<ProtectedRoute module="user_management"><LoginHistory /></ProtectedRoute>} />
              {/* Modules to be built in subsequent phases */}
              <Route path="/crm" element={<CrmRoute><Enquiries /></CrmRoute>} />
              <Route path="/crm/:id" element={<CrmRoute><EnquiryDetail /></CrmRoute>} />
              <Route path="/customers" element={<CustomersRoute><Customers /></CustomersRoute>} />
              <Route path="/customers/new" element={<CustomersRoute><CustomerForm /></CustomersRoute>} />
              <Route path="/customers/:id" element={<CustomersRoute><CustomerDetail /></CustomersRoute>} />
              <Route path="/customers/:id/edit" element={<CustomersRoute><CustomerForm /></CustomersRoute>} />
              <Route path="/products" element={<ProtectedRoute module="products"><Products /></ProtectedRoute>} />
              <Route path="/artwork" element={<ArtworkRoute><ArtworkList /></ArtworkRoute>} />              <Route path="/artwork/:id" element={<ArtworkRoute><ArtworkDetail /></ArtworkRoute>} />
              <Route path="/quotations" element={<QuotationsRoute><Quotations /></QuotationsRoute>} />
              <Route path="/quotations/new" element={<QuotationsRoute><QuotationForm /></QuotationsRoute>} />
              <Route path="/quotations/:id" element={<QuotationsRoute><QuotationDetail /></QuotationsRoute>} />
              <Route path="/quotations/:id/edit" element={<QuotationsRoute><QuotationForm /></QuotationsRoute>} />
              <Route path="/sales-orders" element={<SalesOrdersRoute><SalesOrders /></SalesOrdersRoute>} />
              <Route path="/sales-orders/new" element={<SalesOrdersRoute><SalesOrderForm /></SalesOrdersRoute>} />
              <Route path="/sales-orders/:id" element={<SalesOrdersRoute><SalesOrderDetail /></SalesOrdersRoute>} />
              <Route path="/sales-orders/:id/edit" element={<SalesOrdersRoute><SalesOrderForm /></SalesOrdersRoute>} />
              <Route path="/production-planning" element={<PlanningRoute><Planning /></PlanningRoute>} />
              <Route path="/production-planning/jobs/new" element={<PlanningRoute><JobForm /></PlanningRoute>} />
              <Route path="/production-planning/jobs/:id" element={<PlanningRoute><JobDetail /></PlanningRoute>} />
              <Route path="/production-planning/jobs/:id/edit" element={<PlanningRoute><JobForm /></PlanningRoute>} />
              <Route path="/production" element={<ProductionRoute><ProductionHub /></ProductionRoute>} />
              <Route path="/production/:stage" element={<ProductionRoute><OperatorWorkspace /></ProductionRoute>} />
              <Route path="/production/:stage/control" element={<ProductionRoute><SupervisorDashboard /></ProductionRoute>} />
              <Route path="/quality-control" element={<QCRoute><QualityControl /></QCRoute>} />
              <Route path="/quality-control/inspections/:id" element={<QCRoute><InspectionDetail /></QCRoute>} />
              <Route path="/inventory" element={<InventoryRoute><Inventory /></InventoryRoute>} />
              <Route path="/inventory/items/:id" element={<InventoryRoute><InventoryItemDetail /></InventoryRoute>} />
              <Route path="/raw-materials" element={<RawMaterialsRoute><RawMaterials /></RawMaterialsRoute>} />
              <Route path="/raw-materials/:id" element={<RawMaterialsRoute><MaterialDetail /></RawMaterialsRoute>} />
              <Route path="/dispatch" element={<DispatchRoute><Dispatch /></DispatchRoute>} />
              <Route path="/dispatch/:id" element={<DispatchRoute><DispatchDetail /></DispatchRoute>} />
              <Route path="/purchase" element={<ProtectedRoute module="purchase"><Purchase /></ProtectedRoute>} />
              <Route path="/suppliers" element={<ProtectedRoute module="suppliers"><Suppliers /></ProtectedRoute>} />
              <Route path="/finance" element={<FinanceRoute><Finance /></FinanceRoute>} />
              <Route path="/finance/invoices/:id" element={<FinanceRoute><InvoiceDetail /></FinanceRoute>} />
              <Route path="/finance/invoices/:id/print" element={<FinanceRoute><InvoicePrint /></FinanceRoute>} />
              <Route path="/hr" element={<ProtectedRoute module="hr"><HR /></ProtectedRoute>} />
              <Route path="/machines" element={<ProtectedRoute module="machines"><Machines /></ProtectedRoute>} />
              <Route path="/reports" element={<ProtectedRoute module="reports"><Reports /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute module="settings"><Settings /></ProtectedRoute>} />
            </Route>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/collections" element={<Collections />} />
              <Route path="/collections/:slug" element={<Collections />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/studio" element={<TryStudio />} />
              <Route path="/manufacturing" element={<Manufacturing />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
